import { initializeApp } from "firebase/app"
// import { onAuthStateChanged } from "firebase/auth";


// Import Vue dependencies
// import Vue from 'vue'
import {createApp} from 'vue'
import App from './App.vue'
import router from './auth-router'

// import AuthUtil from '../authUtil'

// NOTE: These are OK to have here and are considered public.
// See https://firebase.google.com/docs/projects/learn-more#config-files-objects
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_SENDER,
  appId: process.env.VUE_APP_FIREBASE_APP_ID
}

// Optional measurement id
if (process.env.VUE_APP_FIREBASE_MEASUREMENT_ID) {
  firebaseConfig.measurementId = process.env.VUE_APP_FIREBASE_MEASUREMENT_ID
}

// firebase.initializeApp(firebaseConfig)
// const firebaseApp = firebase.initializeApp(firebaseConfig)
const firebaseApp = initializeApp(firebaseConfig);
// AuthUtil.init(firebaseApp)
// Vue.prototype.$firebaseApp = firebaseApp


let app = ''

// onAuthStateChanged(AuthUtil.auth, () => {
  if (!app) {
    app = createApp(App)
    /* eslint-disable no-new */
    // app = new Vue({
    //   router,
    //   render: h => h(App)
    // }).$mount('#app')

    app.use(router).mount('#app')

    app.provide('firebase', firebaseApp)
  }
// })